import { Text } from '@backstage/ui';

import { ActivityItem } from '@spotify/plugin-confidence-activity-react';

import { DeltaText } from '../DeltaText';
import type { Rule } from './types';

export const DescriptionSection = ({
  oldRule,
  newRule,
}: {
  oldRule?: Rule;
  newRule?: Rule;
}) => {
  if (!oldRule?.description && !newRule?.description) {
    return null;
  }

  return (
    <ActivityItem.Section label="Description">
      {oldRule && newRule && oldRule.description !== newRule.description ? (
        <DeltaText
          oldText={oldRule?.description ?? ''}
          newText={newRule?.description ?? ''}
        />
      ) : (
        <Text variant="body-medium">
          {newRule?.description ?? oldRule?.description ?? ''}
        </Text>
      )}
    </ActivityItem.Section>
  );
};
